import { styled } from '~/styled'

export const TableCell = styled('td', {
  base: [
    'border-t',
    'border-t-grey-100',
    'box-border',
    'text-grey-800',
    'font-body',
    'leading-normal',
    'text-left',
    'align-middle',
    'first:font-semibold'
  ]
})

TableCell.displayName = 'TableCell'
